import React from 'react';

import './placeholder-card.scss';

export function PlaceholderCard() {
  return (
    <div className="electric-car-incentive-placeholder-card pos-a p-1 d-flex flex-column justify-content-between">
      <div className="ph-gray ph-large mb-0_5" />
      <div className="ph-gray ph-large mb-0_5" />
      <div className="ph-gray ph-large-half mb-1_5" />
      <div className="ph-gray ph-xlarge mx-auto mb-1_5" />
      <div className="d-flex justify-content-between">
        <div className="ph-gray ph-xsmall mb-1" />
        <div className="ph-gray ph-msmall mb-1" />
      </div>
      <div className="d-flex justify-content-between">
        <div className="ph-gray ph-small mb-1" />
        <div className="ph-gray ph-msmall mb-1" />
      </div>
      <div className="ph-gray ph-large-half text-end" />
    </div>
  );
}
